export default __webpack_public_path__ + "static/media/avatar6.bd083553.svg";